<template>
  <div class="classicUserCreateWrapper">
    <CreateUserTemplate
      :first-name="USER.first_name"
      :email="USER.email"
      @update-email="SET_USER({ ...USER, email: $event })"
      @update-first-name="SET_USER({ ...USER, first_name: $event })"
      @request-signup="finalizeSignup"
    >
      <template v-slot:top>
        <div class="facebookPromp" @click="$emit('request-facebook-signup')">
          <span class="plain">{{
            $t("band.signup.init.classicUser.text.facebookPrompt")
          }}</span>
          <span class="colored">{{
            $t("band.signup.init.classicUser.button.facebookPrompt")
          }}</span>
        </div>
        <div class="orBar">
          <div class="line"></div>
          <div class="orText">{{ $t("common.or") }}</div>
          <div class="line"></div>
        </div>
      </template>
      <template v-slot:mid>
        <div class="toggleVisual" @click="displayPassword = !displayPassword">
          <transition name="fade" mode="out-in">
            <span v-if="!displayPassword" key="show" class="text">{{
              $t("common.show")
            }}</span>
            <span v-else key="hide" class="text">{{ $t("common.hide") }}</span>
          </transition>
          <transition name="fade" mode="out-in">
            <i v-if="!displayPassword" key="show" class="far fa-eye"></i>
            <i v-else key="hide" class="far fa-eye-slash"></i>
          </transition>
        </div>
        <TextInput
          v-model="password"
          v-validate:password
          picto="fas fa-unlock-alt"
          :placeholder="
            $t('band.signup.init.classicUser.input.passwordPlaceholder')
          "
          :type="inputType"
          @focus="displayPasswordAnotation = true"
          @blur="displayPasswordAnotation = false"
        >
          <template v-slot:errormsg>
            <div v-if="!password.length" class="errormsg">
              {{ $t("errors.input.required_field") }}
            </div>
            <div class="errormsg">
              {{ $tc("errors.input.min_characters", 8) }}
            </div>
          </template>
        </TextInput>
        <transition name="fade" mode="out-in">
          <div
            v-if="displayPasswordAnotation && validity.password"
            class="tw-color-gray-400 tw-mt-2"
          >
            <span>x</span>
            <span>{{ $tc("errors.input.min_characters", 8) }}</span>
          </div>
        </transition>
      </template>
    </CreateUserTemplate>
  </div>
</template>
<script>
import CreateUserTemplate from "~/components/band/signup/init/createUser/template"
import TextInput from "~/components/inputs/text"

import SharedDataMixin from "./createUser/sharedData.js"
import ValidityMixin from "~/mixins/validity"
import EventMixin from "~/mixins/events"

import createUserTracking from "~/helpers/signup/createUserTracking.js"

export default {
  components: {
    CreateUserTemplate,
    TextInput,
  },
  mixins: [SharedDataMixin, ValidityMixin, EventMixin],
  data() {
    return {
      displayPasswordAnotation: false,
      password: "",
      displayPassword: false,
      validity: {
        password: true,
      },
    }
  },
  computed: {
    inputType() {
      return this.displayPassword ? "text" : "password"
    },
  },
  methods: {
    createUserTracking,
    validate_password() {
      return this.checkPassword(this.password)
    },
    trackFinalizeEvent() {
      this.createUserTracking()
      this.trackEvent({
        category: "Band Signup",
        action: "Create User",
        label: "mail",
      })
    },
    finalizeSignup() {
      if (this.validate()) {
        this.checkForAlreadyExistingUsr()
          .then(() => {
            this.$axios
              .$post("/auth/user/", {
                password: this.password,
                email: this.USER.email,
                first_name: this.USER.first_name,
                is_active: true,
                lang: this.LANG,
              })
              .then((resp) => {
                this.trackFinalizeEvent()
                this.SET_USER(resp)
                this.$emit("signup-success")
              })
              .catch((err) => {
                this.$sentry.captureException(err)
              })
          })
          .catch(() => {
            console.info("User already here, swapping to login prompt")
          })
      }
    },
  },
}
</script>
<style scoped>
.toggleVisual {
  cursor: pointer;
  margin-bottom: 4px;
  font-size: var(--font-size-nano);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: var(--color-param);
}

.toggleVisual > i {
  margin-left: 4px;
}

.facebookPromp {
  text-align: center;
  cursor: pointer;
  margin-bottom: 24px;
  font-weight: 600;
}

.orBar {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.orText {
  margin: 0px 24px;
  color: var(--color-dark-grey);
  font-weight: 600;
}

.line {
  height: 1px;
  width: 100%;
  background-color: var(--color-grey);
}

.plain {
  color: var(--color-black);
}

.colored {
  color: var(--color-main);
}
</style>
